import UniqueSellingPoint from 'themes/base/components/shop/UniqueSellingPoint'

export default {
  extends: UniqueSellingPoint,
}
